import { Modal } from 'antd';
import React, { useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useAppSelector } from '../store/hooks';

export const StatisticsModal = () => {
  const totalTrajectories = useAppSelector(state => state.entities.trajectory.totalTrajectories);
  const totalPoints = useAppSelector(state => state.entities.trajectory.totalPoints);
  const totalHardBrakingEvents = useAppSelector(state => state.entities.trajectory.totalHardBrakingEvents);
  const totalHardAccelerationEvents = useAppSelector(state => state.entities.trajectory.totalHardAccelerationEvents);
  const totalTravelTimePoints = useAppSelector(state => state.entities.trajectory.totalTravelTimePoints);

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const setModalVisible = () => setIsModalVisible(true);
  const setModalInvisible = () => setIsModalVisible(false);

  useHotkeys('s', () => setModalVisible());

  return (
    <Modal title="Statistics"
           visible={isModalVisible}
           footer={null}
           okButtonProps={{ onClick: setModalInvisible }}
           onCancel={setModalInvisible}>
      <div>Total Trajectories: {totalTrajectories}</div>
      <div>Total Points: {totalPoints}</div>
      <div>Total Hard Braking Events: {totalHardBrakingEvents}</div>
      <div>Total Hard Acceleration Events: {totalHardAccelerationEvents}</div>
      <div>Total Travel Time Points: {totalTravelTimePoints}</div>
    </Modal>
  );
};
